import React from 'react';
import styled from 'styled-components';
import { colors } from '_styles';
import { _ } from '_locales';
import HOC from '_HOC';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Title = styled.h2`
    font-size: 20px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    color: #000;
    text-align: left;
`;

const Description = styled.h4`
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    color: #747474;
    line-height: 1.8em;
`;

const ExitButton = styled.button`
    border: none;
    margin: 0 auto;
    display: block;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer !important;
    color: ${colors.RC_ACTION};
    background-color: transparent;
    text-decoration: underline;
`;

const ReviewSticker = ({ props }) => {
  const { history } = props;

  return (
    <Container>
      <Title>{_('help.review_the_sticker')}</Title>

      <Description>
        {_('help.please_review_the_information_on_the_sticker')}
      </Description>

      <ExitButton onClick={() => history.push('/help')}>{_('reminder.exit')}</ExitButton>
    </Container>
  );
};

export default HOC(ReviewSticker);
